import { createEnv } from "@t3-oss/env-core";
import { minLength, optional, picklist, pipe, string } from "valibot";

export const env = createEnv({
  client: {
    VITE_GA_ID: optional(pipe(string(), minLength(1))),
    VITE_GTM_ID: optional(pipe(string(), minLength(1))),
    VITE_META_PIXEL_ID: optional(pipe(string(), minLength(1))),
    VITE_SENTRY_DSN: optional(pipe(string(), minLength(1))),
  },
  clientPrefix: "VITE_",
  emptyStringAsUndefined: true,
  runtimeEnv: import.meta.env,
  server: {},
  shared: {
    NODE_ENV: optional(
      picklist(["development", "production", "test"]),
      "development"
    ),
  },
  skipValidation:
    !!process.env.CI || process.env.npm_lifecycle_event === "lint",
});
